var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulkAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.181,
    height: 15.112,
    viewBox: "0 0 20.181 15.112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_95326",
    "data-name": "Path 95326",
    d: "M3.394,11.064H2.1a.954.954,0,0,1-.953-.953v-4.2A.954.954,0,0,1,2.1,4.96H3.5A5.171,5.171,0,0,1,3.433,4.2c0-.129.01-.254.02-.382H2.1A2.1,2.1,0,0,0,0,5.913v4.2a2.1,2.1,0,0,0,2.1,2.1h1.3v.8a2.1,2.1,0,0,0,2.1,2.1H18.083a2.1,2.1,0,0,0,2.1-2.1v-4.2a2.1,2.1,0,0,0-2.1-2.1h-1.3v-.8a2.1,2.1,0,0,0-2.1-2.1H13.334c.01.127.02.252.02.382a5.171,5.171,0,0,1-.065.763h1.4a.956.956,0,0,1,.955.953v4.2a.956.956,0,0,1-.955.953H4.537m14.5,1.947a.955.955,0,0,1-.953.955H5.492a.956.956,0,0,1-.955-.955v-.8H14.689a2.1,2.1,0,0,0,2.1-2.1V7.862h1.3a.953.953,0,0,1,.953.953ZM4.2,4.2a4.2,4.2,0,0,0,4.2,4.2,4.363,4.363,0,0,0,4.2-4.386A4.037,4.037,0,0,0,8.394,0,4.2,4.2,0,0,0,4.2,4.2m1.145,0a.381.381,0,0,1,.382-.382h2.29V1.525a.382.382,0,0,1,.763,0v2.29h2.288a.382.382,0,1,1,0,.763H8.776v2.29a.382.382,0,0,1-.763,0V4.578H5.723A.381.381,0,0,1,5.341,4.2",
    fill: "#2a60bc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkAdd);
export default __webpack_public_path__ + "static/media/bulkAdd.f9e056176d5d373ac8ce39fb1c49f11a.svg";
export { ForwardRef as ReactComponent };